import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { parseOsType } from '../../../framework/device-utils';

@Component({
  selector: 'app-os-icon',
  templateUrl: './os-icon.component.html',
  styleUrls: ['./os-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OsIconComponent {
  readonly os = input<string>('');

  readonly iconSrc = computed(() => {
    const type = parseOsType(this.os());
    if (!type) return null;
    return `/assets/img/devices/${type}.svg`;
  });
}
